module.exports = __webpack_public_path__ + "h5/img/promotionTitle.dcdb5bfc.png";